/**
 * LoadingScreen functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class LoadingScreen {
  /**
   * Constructs a new LoadingScreen instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.element.addEventListener('transitionend', () => {
      if (document.body.classList.contains('home-loaded')) {
        document.body.classList.add('scrolling-allowed')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/loading-screen/index.js